import { render, staticRenderFns } from "./Inserate.vue?vue&type=template&id=7b752844&scoped=true"
import script from "./Inserate.vue?vue&type=script&lang=js"
export * from "./Inserate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b752844",
  null
  
)

export default component.exports